import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getRevaluationList } from '@store/Finance/FixedAssets/Revaluation/RevaluationSlice';
// import { useTranslation } from 'react-i18next';

const useGetRevaluationList = () => {
  const dispatch = useAppDispatch();
  // const { t, i18n } = useTranslation();

  useEffect(() => {
    // if (AssetsList?.length === 0) {
    dispatch(getRevaluationList());
    // }
  }, []);
  const { RevaluationList, loading, error } = useAppSelector(state => state.Revaluation);

  // var OptionsAssets = RevaluationList?.map(({ id, name, name2 }) => ({
  //   value: id,
  //   label: `${i18n.language === 'en' ? name : name2}`,
  // }));

  return { RevaluationList, loading, error };
};

export default useGetRevaluationList;
